export default function ({commit, dispatch}, val) {

    commit('set_form',{
        Sum: val,
    });
    dispatch('regular_resum');
}